import React from 'react';
import './ApproachSection.css';

const ApproachSection = () => {
  const approaches = [
    {
      title: 'Research',
      description: 'Research is at the core of the products we are looking to build — Neural Interfaces, Solar and Cultural Systems. In each domain, it drives our creative edge.',
      keywords: ['Deep Research', 'Multi-Domain', 'Innovation', 'Discovery']
    },
    {
      title: 'Design',
      description: 'Product design is iterative and customer-centric. Products balance form and function.',
      keywords: ['Iterative', 'Customer-Centric', 'Form', 'Function']
    },
    {
      title: 'Build',
      description: 'Build focuses on quality and adaptability. We engineered to operate at scale and deliver impact.',
      keywords: ['Quality', 'Scale', 'Adaptability', 'Impact']
    }
  ];

  return (
    <section id="approach" className="approach-section section-padding">
      <div className="container">
        <div className="approach-header observe-fade">
          <div className="section-label">Our Approach</div>
          <h2 className="heading-1">Research → Design → Build</h2>
          <p className="approach-intro body-large">
            We turn deep, multi-domain research into products that scale.
          </p>
        </div>

        <div className="approach-grid">
          {approaches.map((item, index) => (
            <div key={index} className="approach-card observe-fade">
              <div className="approach-icon">
                <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                  {index === 0 && (
                    // Research - concentric circles with center focus
                    <g>
                      <circle cx="30" cy="30" r="24" fill="none" stroke="#d4af37" strokeWidth="1" opacity="0.5" />
                      <circle cx="30" cy="30" r="16" fill="none" stroke="#d4af37" strokeWidth="1" opacity="0.7" />
                      <circle cx="30" cy="30" r="8" fill="none" stroke="#d4af37" strokeWidth="1.5" />
                      <circle cx="30" cy="30" r="3" fill="#d4af37" opacity="0.8" />
                    </g>
                  )}
                  {index === 1 && (
                    // Design - grid/blueprint
                    <g>
                      <rect x="10" y="10" width="40" height="40" fill="none" stroke="#d4af37" strokeWidth="1.5" opacity="0.6" />
                      <line x1="10" y1="30" x2="50" y2="30" stroke="#d4af37" strokeWidth="1" opacity="0.5" />
                      <line x1="30" y1="10" x2="30" y2="50" stroke="#d4af37" strokeWidth="1" opacity="0.5" />
                      <rect x="20" y="20" width="20" height="20" fill="none" stroke="#d4af37" strokeWidth="1.5" opacity="0.7" />
                    </g>
                  )}
                  {index === 2 && (
                    // Build - building blocks
                    <g>
                      <path d="M 30 10 L 45 30 L 30 50 L 15 30 Z" fill="none" stroke="#d4af37" strokeWidth="1.5" opacity="0.6" />
                      <path d="M 30 20 L 40 30 L 30 40 L 20 30 Z" fill="none" stroke="#d4af37" strokeWidth="1.5" opacity="0.8" />
                      <circle cx="30" cy="30" r="3" fill="#d4af37" />
                    </g>
                  )}
                </svg>
              </div>

              <h3 className="heading-3 approach-title">{item.title}</h3>
              <p className="body-regular approach-description">{item.description}</p>
              
              <div className="approach-keywords">
                {item.keywords.map((keyword, i) => (
                  <span key={i} className="keyword-tag">{keyword}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Decorative gold divider */}
      <div className="approach-divider">
        <svg width="100%" height="2" xmlns="http://www.w3.org/2000/svg">
          <line x1="0" y1="1" x2="100%" y2="1" stroke="#d4af37" strokeWidth="1" opacity="0.3" />
        </svg>
      </div>
    </section>
  );
};

export default ApproachSection;